import { Selector } from '@ngxs/store';

import { EmailNotificationPreference } from '../../models/email-notification.model';
import {
  EmailNotificationState,
  EmailNotificationStateModel,
} from '../email-notification.state';

export class EmailNotificationSelectors {
  @Selector([EmailNotificationState])
  static isLoading(state: EmailNotificationStateModel): boolean {
    return state.isLoading;
  }

  @Selector([EmailNotificationState])
  static loadError(state: EmailNotificationStateModel): string | null {
    return state.loadError;
  }

  @Selector([EmailNotificationState])
  static isUpdating(state: EmailNotificationStateModel): boolean {
    return state.isUpdating;
  }

  @Selector([EmailNotificationState])
  static updateError(state: EmailNotificationStateModel): string | null {
    return state.updateError;
  }

  @Selector([EmailNotificationSelectors._managePreferencesEmailNotification])
  static managePreferencesEmailNotification(
    managePreferencesEmailNotification: EmailNotificationPreference[],
  ): EmailNotificationPreference[] {
    return managePreferencesEmailNotification;
  }

  @Selector([EmailNotificationState])
  private static _managePreferencesEmailNotification(
    state: EmailNotificationStateModel,
  ): EmailNotificationPreference[] {
    return state.notificationsList;
  }
}
